export const environment = {
  production: false,
  apiUrl: 'https://producerportal-api-dev.anzcofoods.com',
  webUrl: 'https://producerportal-dev.anzcofoods.com',
  releaseVersion: 'BuildNo Dev: 20260720.1',
  advantageUrl: 'https://anzcoadvantage-uat.ichange360.com',
  raygunKey: 'cq0Fn0I2aqhkyGfTXGoQFA',
};
